var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "new-journal"
  }, [_c('HeaderNewCopy'), _c('div', {
    staticClass: "pc consult-page"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-info"
  }, [_vm._m(0), _vm._m(1), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Получить консультацию"
    },
    on: {
      "buttonAction": _vm.getConsult
    }
  })], 1), _c('img', {
    staticClass: "elements-img",
    attrs: {
      "src": require("@/assets/img/consult-img.png"),
      "alt": "phone elements"
    }
  })]), _c('div', {
    staticClass: "full-width"
  }, [_c('div', {
    staticClass: "benefits"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h2', {
    staticClass: "sub-title"
  }, [_vm._v("Решите ваш вопрос прямо сейчас")]), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Получить консультацию"
    },
    on: {
      "buttonAction": _vm.getConsult
    }
  })], 1), _vm._m(2)])]), _c('div', {
    staticClass: "faq"
  }, [_c('h2', {
    staticClass: "sub-title"
  }, [_vm._v("FAQ")]), _c('div', {
    staticClass: "questions"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-head",
    on: {
      "click": function click() {
        return _vm.showQuestion(99);
      }
    }
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Что мне нужно сделать, чтобы получить консультацию?")]), _c('div', {
    staticClass: "img",
    class: {
      active: _vm.currentFaq === 99
    }
  })]), _c('p', {
    staticClass: "text",
    class: {
      active: _vm.currentFaq === 99
    }
  }, [_vm._v("Просто задайте свой вопрос в нашем телеграм-боте. Для этого перейдите "), _c('a', {
    attrs: {
      "href": "https://t.me/Finsite_bot"
    }
  }, [_vm._v("по ссылке")]), _vm._v(", нажмите кнопку 'Начать' и задайте свой вопрос ")])]), _vm._l(_vm.questions, function (item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item-head",
      on: {
        "click": function click() {
          return _vm.showQuestion(index);
        }
      }
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "img",
      class: {
        active: _vm.currentFaq === index
      }
    })]), _c('p', {
      staticClass: "text",
      class: {
        active: _vm.currentFaq === index
      }
    }, [_vm._v(_vm._s(item.text) + " ")])]);
  })], 2)])]), _c('div', {
    staticClass: "phone consult-page"
  }, [_c('div', {
    staticClass: "main"
  }, [_vm._m(3), _c('img', {
    staticClass: "elements-img",
    attrs: {
      "src": require("@/assets/img/consult-img.png"),
      "alt": "phone elements"
    }
  }), _c('div', {
    staticClass: "main-info"
  }, [_vm._m(4), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Получить консультацию"
    },
    on: {
      "buttonAction": _vm.getConsult
    }
  })], 1)]), _c('div', {
    staticClass: "full-width"
  }, [_c('div', {
    staticClass: "benefits"
  }, [_c('h2', {
    staticClass: "sub-title"
  }, [_vm._v("Делаем все для повышения вашей финансовой грамотности")]), _vm._m(5), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Получить консультацию"
    },
    on: {
      "buttonAction": _vm.getConsult
    }
  })], 1)]), _c('div', {
    staticClass: "faq"
  }, [_c('h2', {
    staticClass: "sub-title"
  }, [_vm._v("FAQ")]), _c('div', {
    staticClass: "questions"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-head",
    on: {
      "click": function click() {
        return _vm.showQuestion(99);
      }
    }
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Что мне нужно сделать, чтобы получить консультацию?")]), _c('div', {
    staticClass: "img",
    class: {
      active: _vm.currentFaq === 99
    }
  })]), _c('p', {
    staticClass: "text",
    class: {
      active: _vm.currentFaq === 99
    }
  }, [_vm._v("Просто задайте свой вопрос в нашем телеграм-боте. Для этого перейдите "), _c('a', {
    attrs: {
      "href": "https://t.me/Finsite_bot"
    }
  }, [_vm._v("по ссылке")]), _vm._v(", нажмите кнопку 'Начать' и задайте свой вопрос ")])]), _vm._l(_vm.questions, function (item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "item-head",
      on: {
        "click": function click() {
          return _vm.showQuestion(index);
        }
      }
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "img",
      class: {
        active: _vm.currentFaq === index
      }
    })]), _c('p', {
      staticClass: "text",
      class: {
        active: _vm.currentFaq === index
      }
    }, [_vm._v(_vm._s(item.text) + " ")])]);
  })], 2)])]), _c('Footer')], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h1', {
    staticClass: "title"
  }, [_vm._v("Получите финансовую консультацию в чате "), _c('br'), _vm._v(" с нашими экспертами")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "message-img"
  }, [_c('p', {
    staticClass: "message"
  }, [_vm._v(" Задайте нам любые вопросы, связанные с финансами - начиная с того, как правильно экономить, и заканчивая тем, как улучшить кредитную историю. Мы поможем вам разобраться, чтобы вы могли быть уверены в своей финансовой грамотности. ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cards"
  }, [_c('div', {
    staticClass: "card_consult"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/icon-comfy.svg"),
      "alt": "comfy icon"
    }
  }), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Удобно")]), _c('p', {
    staticClass: "text"
  }, [_vm._v("Получите ответ на свой вопрос в телеграм-чате, переписка всегда будет у вас под рукой.")])]), _c('div', {
    staticClass: "card_consult"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/icon-simple.svg"),
      "alt": "simple icon"
    }
  }), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Просто")]), _c('p', {
    staticClass: "text"
  }, [_vm._v("Донесем информацию доступно и понятно, без сложных терминов и неоднозначных деталей.")])]), _c('div', {
    staticClass: "card_consult"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/icon-profitable.svg"),
      "alt": "profitable icon"
    }
  }), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Выгодно")]), _c('p', {
    staticClass: "text"
  }, [_vm._v("Получите качественный ответ от специалиста в области финансов всего за 499 рублей.")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h1', {
    staticClass: "title"
  }, [_vm._v("Получите финансовую консультацию "), _c('br'), _vm._v("в чате с нашими экспертами")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "message-wrapper"
  }, [_c('p', {
    staticClass: "message"
  }, [_vm._v(" Задайте нам любые вопросы, связанные "), _c('br'), _vm._v(" с финансами. Мы поможем вам "), _c('br'), _vm._v(" разобраться, чтобы вы могли быть уверены "), _c('br'), _vm._v(" в своей финансовой грамотности. ")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cards"
  }, [_c('div', {
    staticClass: "card_consult"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/icon-comfy.svg"),
      "alt": "comfy icon"
    }
  }), _c('div', {
    staticClass: "card-info"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Удобно")]), _c('p', {
    staticClass: "text"
  }, [_vm._v("Получите ответ на свой вопрос "), _c('br'), _vm._v("в телеграм-чате, переписка всегда будет у вас под рукой. ")])])]), _c('div', {
    staticClass: "card_consult"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/icon-simple.svg"),
      "alt": "simple icon"
    }
  }), _c('div', {
    staticClass: "card-info"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Просто")]), _c('p', {
    staticClass: "text"
  }, [_vm._v("Донесем информацию доступно и понятно, без сложных терминов и неоднозначных деталей.")])])]), _c('div', {
    staticClass: "card_consult"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/icon-profitable.svg"),
      "alt": "profitable icon"
    }
  }), _c('div', {
    staticClass: "card-info"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Выгодно")]), _c('p', {
    staticClass: "text"
  }, [_vm._v("Получите качественный ответ от специалиста в области финансов всего за 499 рублей.")])])])]);
}]

export { render, staticRenderFns }